import culture from './culture.model'
import nature from './nature.model'
import outdoor from './outdoor.model'
import service from './service.model'
import typicalProduct from './typicalProduct.model'
import itinerary from './itinerary.model'

let Model = function () {
  'ngInject'

  return {
    getModelsConstant: getModelsConstant,
    getByEnum: getByEnum,
    getModel: getModel,
    getNatureStructure: getNatureStructure,
    getOutdoorStructure: getOutdoorStructure,
    getCultureStructure: getCultureStructure,
    getServiceStructure: getServiceStructure,
    getTypicalProductStructure: getTypicalProductStructure,
    getItineraryStructure: getItineraryStructure
  }

  /**
   *Enum: usato per caricare le immagini su s3
   * Name: usato per l'ng-model (in nome del campo tornato dal server)
   */
  function getModelsConstant() {
    return {
      CULTURE: {enum: 'CULTURE', name: 'culture'},
      ITINERARY: {enum: 'ITINERARY', name: 'itinerary'},
      INFORMATION: {enum: 'INFORMATION', name: 'information'},
      NATURE: {enum: 'NATURE', name: 'nature'},
      TYPICALPRODUCT: {enum: 'TYPICALPRODUCT', name: 'typicalProduct'},
      SERVICE: {enum: 'SERVICE', name: 'service'},
      OUTDOOR: {enum: 'OUTDOOR', name: 'outdoor'},
    }
  }

  function getByEnum(modelEnum) {
    let models = getModelsConstant()
    if (_.has(models, modelEnum)) {
      return _.get(models, modelEnum)
    }
    throw 'Unknown model type'
  }

  function getModel(serverResponce) {
    if (_.has(serverResponce, 'culture'))
      return getModelsConstant().CULTURE
    else if (_.has(serverResponce, 'information')) {
      return getModelsConstant().INFORMATION
    }
    else if (_.has(serverResponce, 'itinerary')) {
      return getModelsConstant().ITINERARY
    }
    else if (_.has(serverResponce, 'nature')) {
      return getModelsConstant().NATURE
    }
    else if (_.has(serverResponce, 'typicalProduct')) {
      return getModelsConstant().TYPICALPRODUCT
    }
    else if (_.has(serverResponce, 'service')) {
      return getModelsConstant().SERVICE
    }
    else if (_.has(serverResponce, 'outdoor')) {
      return getModelsConstant().OUTDOOR
    }
    else {
      throw 'Unknown model type'
    }

  }

  function getCultureStructure() {
    return culture;
  }
  function getNatureStructure() {
    return nature;
  }
  function getOutdoorStructure() {
    return outdoor;
  }
  function getServiceStructure() {
    return service;
  }
  function getTypicalProductStructure() {
    return typicalProduct;
  }
  function getItineraryStructure() {
    return itinerary;
  }

}

export default Model



// WEBPACK FOOTER //
// ./client/app/common/factories/modelFactory/model.service.js